import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=721c3743&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts&setup=true"
export * from "./Message.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Message.vue?vue&type=style&index=0&id=721c3743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c3743",
  null
  
)

export default component.exports